var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.777 1.334h-1.333V0h-.889v1.334h-7.11V0h-.89v1.334H2.223A2.225 2.225 0 0 0 0 3.556v10.222C0 15.003.997 16 2.223 16h11.555A2.225 2.225 0 0 0 16 13.778V3.555a2.225 2.225 0 0 0-2.223-2.221Zm1.333 12.443c0 .735-.598 1.333-1.332 1.333H2.223a1.335 1.335 0 0 1-1.334-1.333v-8H15.11v8Zm0-8.888H.89V3.555c0-.735.598-1.333 1.334-1.333h1.333v.888h.888v-.888h7.111v.89h.889v-.89h1.333c.735 0 1.333.598 1.333 1.333V4.89Z",
    fill: "#000"
  })));
};
export default SvgCalendarIcon;